/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBalance = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13 7h6v4h3v2.375C22 15.498 20.08 17 18 17s-4-1.502-4-3.625V11h3V9h-4v11h4v2H7v-2h4V9H7v2h3v2.375C10 15.498 8.08 17 6 17s-4-1.502-4-3.625V11h3V7h6V2h2zm-9 6.375C4 14.151 4.766 15 6 15s2-.849 2-1.625V13H4zm12 0c0 .776.766 1.625 2 1.625s2-.849 2-1.625V13h-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBalance as Balance };
